import { Component, ViewChild, Injector, Input, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { IItem } from '../../interfaces/item.interface';
import { DialogResult } from '../mazars-dialog/dialog-result';
import { MazarsDialogComponent } from '../mazars-dialog/mazars-dialog.component';
import { Acceptor } from '../mazars-dialog/acceptor';
import { SetAssignedUserFacade } from '@app/shared/common/facades/set-assigned-user.facade';
import { IAssignableUserDto } from '@shared/service-proxies/common-interfaces';

@Component({
    selector: 'app-mazars-assignable-user-select-edit-modal-v2',
    templateUrl: './mazars-assignable-user-select-edit-modal-v2.component.html',
})
export class MazarsAssignableUserSelectEditModalV2Component extends AppComponentBase implements OnInit {
    @ViewChild('editModal', { static: true }) modal: MazarsDialogComponent;
    @Input('uid') uid: string;
    assignedUserId: number;
    setAssignedUserFacade: SetAssignedUserFacade;

    form: FormGroup;
    assignableUsers: IItem<number>[];

    constructor(injector: Injector, private fb: FormBuilder) {
        super(injector);
    }

    ngOnInit(): void {
        this.createForm();
    }

    show(
        entitiyId: number,
        permissionNeeded: string,
        assignedUserId: number,
        setAssignedUserFacade: SetAssignedUserFacade,
        rootEntityId?: number
    ): DialogResult {
        this.assignedUserId = assignedUserId;
        this.setAssignedUserFacade = setAssignedUserFacade;
        this.form.reset();
        if (rootEntityId) {
            this.setAssignedUserFacade.getAllPossibleUsers(rootEntityId, permissionNeeded);
        } else {
            this.setAssignedUserFacade.getAllPossibleUsers(entitiyId, permissionNeeded);
        }

        this.addDataSubscriptions();
        return this.modal.show();
    }

    beforeSubmit(acceptor: Acceptor): void {
        let result = this.form.value.assignedUserId;
        acceptor.accept(result);
    }

    private createForm(): void {
        this.form = this.fb.group({
            assignedUserId: [null],
        });
    }

    private addDataSubscriptions(): void {
        this.subscriptions.push(
            this.setAssignedUserFacade.allPossibleUsers$.subscribe((result) => {
                if (result) {
                    let users = result.map(
                        (user) =>
                            ({
                                id: user.userOrOrganizationId,
                                fullName: user.displayName,
                            } as IAssignableUserDto)
                    );
                    this.assignableUsers = users.map((u) => <IItem<number>>{ id: u.id, text: u.fullName, source: u });
                    this.form.reset();
                    if (this.assignableUsers.find((s) => s.id === this.assignedUserId) != null) {
                        this.form.setValue({
                            assignedUserId: this.assignedUserId,
                        });
                    }
                }
            })
        );
    }
}
